import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, BLOCKS, INLINES } from '@contentful/rich-text-types';
import { formatLink } from '@/utils/utils';
import { Paragraph } from 'components/src/typography';
import Link from 'next/link';

type Props = {
  data: Document | undefined;
};

const RichTextContainer = ({ data }: Props) => {
  return documentToReactComponents(data as Document, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        return <Paragraph classes="text-black-75 empty:h-[18px]">{children}</Paragraph>;
      },
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <Link
            href={formatLink(node.data.uri)}
            className="text-md leading-[26px] text-red-100 hover:underline hover:decoration-red-100"
          >
            {children}
          </Link>
        );
      },
    },
  });
};
export default RichTextContainer;
